import { computed } from 'vue';

import type { SlaAction } from '@/gen/types';
import { useSlaAccessStore } from '@/stores/sla-access';

/**
 * Single source of truth for SLA UI gating (pattern: use-incident-audience). Triggers the
 * once-per-session permissions fetch and exposes reactive access state; consumers gate nav
 * entries, routes and controls with `hasAnyAccess` / `can(action)`. Empty grants (no SLA role,
 * customer users, fetch failure) means the whole SLA/onboarding surface stays hidden —
 * deny-by-default, mirroring the API (docs/sla-access.md).
 */
export function useSlaPermissions() {
    const store = useSlaAccessStore();
    void store.fetchOnce();

    return {
        roles: computed(() => store.roles),
        grants: computed(() => store.grants),
        ready: computed(() => store.loaded),
        hasAnyAccess: computed(() => store.hasAnyAccess),
        can: (action: SlaAction) => store.can(action),
    };
}
